import { useState } from "react";
import axios from "axios";
const base_URL = process.env.REACT_APP_API_BASE_URL;

const useUploadImage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const uploadImage = async (file, location) => {
    console.log(file);
    if (!file) return;

    const formData = new FormData();
    Array.from(file).forEach((img) => {
      formData.append("images", img);
    });
    formData.append("location", location);

    try {
      setLoading(true);
      setError(null);
      const response = await axios.post(base_URL + "/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      return response.data;
      // setData(response.data);
    } catch (err) {
      setError(err.response?.data || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return { uploadImage, loading, error, data };
};

export default useUploadImage;
